import axios from "axios";
// import WaterSVG from "../assets/images/SVG/water.svg";
// import PlantsSVG from "../assets/images/SVG/plants.svg";
// import FoodSVG from "../assets/images/SVG/food.svg";
// import BodySVG from "../assets/images/SVG/body.svg";
// import AnimalsSVG from "../assets/images/SVG/animals.svg";
// import FoodPNG from "../assets/images/food.png";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
});

async function fetchTopics(token, subject, level) {
  try {
    const response = await API.post("/topics", { token, subject, level });
    // const response = {
    //   data: [
    //     { id: 1, name: "Science", image: WaterSVG },
    //     { id: 2, name: "English", image: PlantsSVG },
    //     { id: 3, name: "Maths", image: FoodSVG },
    //     { id: 3, name: "Maths", image: BodySVG },
    //     { id: 3, name: "Maths", image: AnimalsSVG },
    //     { id: 1, name: "Science", image: WaterSVG },
    //     { id: 1, name: "Science", image: WaterSVG },
    //     { id: 4, name: "Science", image: FoodPNG }
    //   ],
    // };
    return response.data;
  } catch (error) {
    console.error("Error fetching subjects:", error);
    throw error;
  }
}

export { fetchTopics };
